/* ========================================
   Manage Membership - Riversol
   JavaScript functionality
   ======================================== */

(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initMembershipCard();
  });

  function initMembershipCard() {
    const membershipBlocks = document.querySelectorAll('.exm_membership_status_block');

    if (!membershipBlocks.length) return;

    membershipBlocks.forEach(function(block) {
      enhancePriceDisplay(block);
      enhanceStatusBadge(block);
      enhanceActionButtons(block);
      setupChargeNowHandler(block);
      setupRefundHandler(block);
      setupUpdatePaymentHandler(block);
      setupSkipMonthHandler(block);
      setupCancelledHandler(block);
      setupPausedHandler(block);
      setupActiveOfferHandler(block);
    });
  }

  // Price display - make CAD smaller
  function enhancePriceDisplay(block) {
    const priceB = block.querySelector('.exm_cms_pd b');
    if (!priceB) return;

    const text = priceB.textContent.trim();

    // Check for two prices (discount scenario) - e.g. "$19.00 CAD 9.99 CAD"
    const discountMatch = text.match(/^\$?([\d,.]+)\s*(CAD|USD|EUR|GBP)\s+([\d,.]+)\s*(CAD|USD|EUR|GBP)$/i);
    if (discountMatch) {
      priceB.innerHTML = '<span class="mm-old-price">$' + discountMatch[1] + '</span> <span class="mm-old-currency">' + discountMatch[2] + '</span> $' + discountMatch[3] + ' <span class="mm-currency">' + discountMatch[4] + '</span>';
      return;
    }

    // Single price - match price and currency
    const match = text.match(/^\$?([\d,.]+)\s*(CAD|USD|EUR|GBP)$/i);
    if (match) {
      priceB.innerHTML = '$' + match[1] + ' <span class="mm-currency">' + match[2] + '</span>';
    } else if (!text.startsWith('$')) {
      priceB.textContent = '$' + text;
    }
  }

  // Status badge is now positioned via CSS (absolute positioning)
  function enhanceStatusBadge() {
    // No JS manipulation needed - CSS handles positioning
  }

  // Enhance action buttons with icons
  function enhanceActionButtons(block) {
    const manageLink = block.querySelector('a.exm_customer_action_manage');
    if (manageLink) {
      // Ensure proper text content
      const text = manageLink.textContent.trim();
      if (text.toLowerCase().includes('manage')) {
        manageLink.innerHTML = 'Manage Membership';
      }
    }
  }

  // Handle "Charge now" button - move to button row and style as button
  function setupChargeNowHandler(block) {
    const chargeNowLink = block.querySelector('[x-bind="showChargeNow"]');
    const skipWrapper = block.querySelector('.exm_skip_month_wrapper');

    if (chargeNowLink && skipWrapper) {
      // Add button class and move to button row
      chargeNowLink.classList.add('mm-action-btn');
      chargeNowLink.textContent = 'Charge Now';
      // Reset any inline styles that might affect height
      chargeNowLink.style.cssText = '';
      skipWrapper.appendChild(chargeNowLink);
    }
  }

  // Handle "Refund" button - move to button row
  function setupRefundHandler(block) {
    const refundBtn = block.querySelector('[x-bind="showRefund"]');
    const skipWrapper = block.querySelector('.exm_skip_month_wrapper');
    const skipBtn = block.querySelector('[x-bind="showSkip"]');

    if (refundBtn && skipWrapper) {
      // Reset inline styles and move to button row after Skip button
      refundBtn.style.cssText = '';
      if (skipBtn && skipBtn.nextSibling) {
        skipWrapper.insertBefore(refundBtn, skipBtn.nextSibling);
      } else {
        skipWrapper.appendChild(refundBtn);
      }
    }
  }

  // Handle "Update payment method" - move inside button wrapper, above buttons
  function setupUpdatePaymentHandler(block) {
    const updatePaymentLink = block.querySelector('[x-bind="showUpdatePayment"]');
    const skipWrapper = block.querySelector('.exm_skip_month_wrapper');

    if (updatePaymentLink && skipWrapper) {
      // Move update payment link inside the skip wrapper, at the beginning (below divider, above buttons)
      updatePaymentLink.classList.add('mm-update-payment');
      skipWrapper.insertBefore(updatePaymentLink, skipWrapper.firstChild);
    }
  }

  // Handle "Skip the month" button click
  function setupSkipMonthHandler(block) {
    const skipBtn = block.querySelector('[x-bind="showSkip"]');
    if (skipBtn) {
      skipBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const scid = this.getAttribute('x-data');

        if (typeof window.showSkipMonthModal === 'function') {
          window.showSkipMonthModal(scid);
        } else {
          console.log('Skip month clicked for subscription:', scid);
        }
      });
    }
  }

  // Handle cancelled memberships - add perks box and update button text
  function setupCancelledHandler(block) {
    const cancelledBadge = block.querySelector('.exm_m_cancelled');
    if (!cancelledBadge) return;

    // Get store credit value from price
    const priceEl = block.querySelector('.exm_cms_pd b');
    let storeCredits = '';
    if (priceEl) {
      const priceText = priceEl.textContent.trim();
      const match = priceText.match(/\$?([\d,.]+)/);
      if (match) {
        storeCredits = '$' + match[1];
      }
    }

    // Update Reactivate button text
    const reactivateBtn = block.querySelector('[x-bind="ShowActivateContent"]');
    if (reactivateBtn) {
      reactivateBtn.textContent = 'Reactivate Membership';

      // Create perks box
      const perksBox = document.createElement('div');
      perksBox.className = 'mm-perks-box';
      perksBox.innerHTML = `
        <div class="mm-perks-title">PERKS YOU'RE MISSING</div>
        <ul class="mm-perks-list">
          <li>10% off all products</li>
          <li>Exclusive member gifts</li>
          <li>${storeCredits} store credits every month</li>
        </ul>
      `;

      // Insert perks box just before the reactivate button
      reactivateBtn.parentNode.insertBefore(perksBox, reactivateBtn);
    }
  }

  // Handle paused memberships - add perks box and update button text
  function setupPausedHandler(block) {
    const pausedBadge = block.querySelector('.exm_m_paused');
    if (!pausedBadge) return;

    // Get store credit value from price
    const priceEl = block.querySelector('.exm_cms_pd b');
    let storeCredits = '';
    if (priceEl) {
      const priceText = priceEl.textContent.trim();
      const match = priceText.match(/\$?([\d,.]+)/);
      if (match) {
        storeCredits = '$' + match[1];
      }
    }

    // Find Resume button
    const resumeBtn = block.querySelector('[x-bind="ShowActivateContent"]');
    if (resumeBtn) {
      resumeBtn.textContent = 'Resume Membership';

      // Create perks box
      const perksBox = document.createElement('div');
      perksBox.className = 'mm-perks-box';
      perksBox.innerHTML = `
        <div class="mm-perks-title">PERKS YOU'RE MISSING</div>
        <ul class="mm-perks-list">
          <li>10% off all products</li>
          <li>Exclusive member gifts</li>
          <li>${storeCredits} store credits every month</li>
        </ul>
      `;

      // Insert perks box just before the resume button
      resumeBtn.parentNode.insertBefore(perksBox, resumeBtn);
    }
  }

  // Handle active offer box - just styling, keep original content
  function setupActiveOfferHandler() {
    // Styling handled via CSS, no content changes needed
  }

  // Format currency display
  function formatCurrency(amount, currency) {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: currency || 'CAD'
    }).format(amount);
  }

  // Format date display
  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }

  // Expose utility functions globally if needed
  window.RiversolMembership = {
    init: initMembershipCard,
    formatCurrency: formatCurrency,
    formatDate: formatDate
  };

})();
